// An agent's own state, listed from the agent rather than from a project, so its
// cross-project document, filed under the portfolio scope, is reachable.
import { Link, useParams } from "react-router-dom";

import { useAgentStateDocuments } from "../api/hooks/useAgentPortfolio";
import styles from "./AgentPortfolioTab.module.css";
import { projectAgentStatePath } from "./learningAgentPaths";

const when = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleString() : "-";

export const AgentStateTab = () => {
  const { agent } = useParams();
  const documents = useAgentStateDocuments(agent ?? null);
  const rows = documents.data?.documents ?? [];

  if (documents.isLoading) {
    return <p className={styles.muted}>Loading state documents…</p>;
  }
  if (documents.isError) {
    return (
      <p className={styles.error}>
        Could not load this agent&apos;s state documents.
      </p>
    );
  }
  if (rows.length === 0) {
    // A normal state, not an error.
    return (
      <p className={styles.muted}>
        This agent has not written a state document yet.
      </p>
    );
  }

  return (
    <section>
      <p className={styles.muted}>
        What this agent has written down and carries between runs. One document
        per thing it maintains - a project it works, or the platform itself.
      </p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Document</th>
            <th>Version</th>
            <th>Last written</th>
            <th>Size</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.project_id}>
              <td>
                <Link to={projectAgentStatePath(row.project_id, agent)}>
                  {row.name}
                </Link>
              </td>
              <td>v{row.version}</td>
              <td>{when(row.updated_at)}</td>
              <td>{Math.round(row.chars / 1000)}k chars</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};
